"use client";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import moment from "moment";
import "moment/locale/tr";

import LocationIcon from "assets/svg/location_icon.svg";
import FinishedIcon from "assets/svg/finished.svg";

import { priceFormatter } from "@/src/helpers/number-formatter";

import BadgeCard from "components/common/badge-card";
import { LazyImage } from "components/common/lazy-image/LazyImage";
import Unit from "@/src/utils/constants/units";

import styles from "./styles.module.css";

const ProjectCard = ({
  title = "",
  companyName = "",
  cityName = "",
  districtName = "",
  area = null,
  flatCount = null,
  deliveryDate = "",
  isImmediateDelivery = null,
  priceVisibility = null,
  priceSummary = "",
  coverPhoto = "",
  projectBadgeCard = null,
  campaigns = [],
  isPremium = null,
  salesStatus = "",
  url = "",
  id,
}) => {
  const momentDate = moment(deliveryDate);
  momentDate.locale("tr");

  const [isOpacity, setIsOpacity] = useState(false);

  useEffect(() => {
    const lastTwoSearchStorage = JSON.parse(localStorage.getItem("view-id-list")) || [];
    if (lastTwoSearchStorage?.includes(id)) {
      setIsOpacity(true);
    }
  }, []);

  const wrapperClass = classNames({
    [styles.wrapper]: true,
    [styles.wrapperOpacity]: isOpacity,
  });

  const projectDeliveryTime = isImmediateDelivery
    ? "Hemen Teslim"
    : deliveryDate && `${momentDate.format("MMMM YYYY")} Teslim`;

  const campainBadge = [];
  const campainElements = campaigns || [];
  const dateStatus = (campain) => {
    const dateNow = Date.now();
    const dateNowFormat = new Date(dateNow);
    const dateCampainFormat = new Date(campain.date);
    if (campain?.isBadge === true && dateCampainFormat - dateNowFormat > 0) {
      campainBadge.push({
        isBadge: campain?.isBadge,
        date: dateCampainFormat,
        type: campain?.name,
        title: campain?.campaignTitle,
      });
    }
  };
  campainElements.forEach((item) => dateStatus(item));
  const campainDateSort = campainBadge.sort((a, b) => b.date - a.date);
  const campainDateActive = campainDateSort.length > 0 ? campainDateSort[0] : null;

  const setLocalStorageView = () => {
    const lastTwoSearchStorage = JSON.parse(localStorage.getItem("view-id-list")) || [];
    if (!lastTwoSearchStorage?.includes(id)) {
      lastTwoSearchStorage.push(id);
      localStorage.setItem("view-id-list", JSON.stringify(lastTwoSearchStorage));
    }
  };

  return (
    <a href={url} onClick={setLocalStorageView} className={wrapperClass}>
      {projectBadgeCard && <div className={styles.projectBadgeCard}>PROJE</div>}
      <div className={styles.imageWrapper}>
        {(isPremium || campainDateActive) && (
          <div className={styles.badgeItem}>
            {isPremium && <BadgeCard type="premium" />}
            {campainDateActive && <BadgeCard type={campainDateActive.type} data={campainDateActive} />}
          </div>
        )}
        <LazyImage
          src={coverPhoto}
          alt={`${title}-${companyName}`}
          className={styles.imageClass}
          wrapperClassName={styles.imageWrapperClass}
          width="258px"
          height="100%"
          visibleByDefault
        />
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.titleWrapper}>
          <h3 className={styles.title}>{title} </h3>
        </div>
        <span className={styles.companyName}>{companyName}</span>
        <div className={styles.locationWrapper}>
          <LocationIcon />
          <span className={styles.location}>{cityName && districtName && `${cityName} - ${districtName}`}</span>
        </div>
        <div className={styles.quickinfoWrapper}>
          {area && `${priceFormatter(area)} ${Unit.M2.name}`} {area && (flatCount || projectDeliveryTime) && ` | `}
          {flatCount && `${flatCount} Konut`} {projectDeliveryTime && ` | ${projectDeliveryTime}`}
        </div>
        <div className={styles.priceContent}>
          <div>
            {salesStatus === "FINISHED" ? (
              <div className={styles.projectFinished}>
                <FinishedIcon />
                <span className={styles.finishedTitle}>Satışı Tamamlandı</span>
              </div>
            ) : (
              <div className={styles.priceWrapper}>
                {(priceVisibility === "ASK" || priceVisibility === "HIDDEN") && (
                  <button className={styles.buttonClass}>Fiyat Sor</button>
                )}
                {priceVisibility === "STARTCOUNT" && (
                  <span>
                    {priceSummary && <span className={styles.price}> {priceSummary}</span>}
                    <span className={styles.startCount}>{`'den başlayan fiyatlarla`}</span>
                  </span>
                )}
                {priceVisibility === "RANGE" && <span className={styles.price}>{priceSummary && priceSummary}</span>}
              </div>
            )}
          </div>
        </div>
      </div>
    </a>
  );
};

ProjectCard.propTypes = {
  title: PropTypes.string,
  companyName: PropTypes.string,
  cityName: PropTypes.string,
  districtName: PropTypes.string,
  area: PropTypes.number,
  flatCount: PropTypes.number,
  deliveryDate: PropTypes.string,
  isImmediateDelivery: PropTypes.bool,
  priceVisibility: PropTypes.string,
  priceSummary: PropTypes.string,
  coverPhoto: PropTypes.string,
  projectBadgeCard: PropTypes.bool,
  campaigns: PropTypes.array,
  isPremium: PropTypes.bool,
  salesStatus: PropTypes.string,
  url: PropTypes.string,
  id: PropTypes.string,
};

export default ProjectCard;
